import { Type } from 'class-transformer';

// Model imports
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';
import { DocumentCategoryResultDto } from './document-category-result-dto';
import { DocumentRawDto } from './document-raw-dto';
import { DocumentSubCategoryResultDto } from './document-subcategory-result-dto';

export class DocumentEditorResultDto {
    @Type(() => DocumentRawDto)
    documentInfo: DocumentRawDto;

    @Type(() => DocumentCategoryResultDto)
    categories: DocumentCategoryResultDto[];

    @Type(() => DocumentSubCategoryResultDto)
    subCategories: DocumentSubCategoryResultDto[];

    @Type(() => KeyValueResultDto)
    fileTypes: KeyValueResultDto[];

    allowToggleCorporateUseOnly: boolean;
}
